import React from 'react';

const LoadingSpinner = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className={`animate-spin rounded-full border-4 border-muted border-t-primary ${sizeClasses[size]}`}></div>
      {text && (
        <p className="mt-4 text-muted-foreground text-sm font-medium">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
